import React from "react";
import Select from "react-select";

export default function ReactSelectBox({
  label,
  options,
  value,
  onChange,
  ...otherprops
}) {
  return (
    <div>
      <label className="text-xs font-bold text-gray-600 ">{label}</label>
      <Select
        className="disabled:text-gray-800 disabled:bg-gray-200 w-80 border rounded-md border-gray-400 focus:outline-none focus:border-blue-500"
        value={value}
        onChange={onChange}
        isDisabled={otherprops.disabled}
        options={options}
        {...otherprops}
      />
    </div>
  );
}
